import { createContext } from "react";
import type { TreeItem } from "../primitives/types";

export type BranchData = { items: TreeItem[]; isLoading: boolean };
export type UseBranchItems = (branchId: string | null) => BranchData;

export const TreeDataContext = createContext<UseBranchItems>(() => ({
	items: [],
	isLoading: false,
}));
